module.exports = __webpack_public_path__ + "img/icon-instagram.0410ab2e5defc81eb643e6e7f059a1b6.svg";